import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../core/http/api.service';
import {UtilsService} from '../../core/services/utils/utils.service';
import { HttpClient, HttpEventType } from '@angular/common/http';

@Component({
    selector: 'app-podcasts',
    templateUrl: './podcasts.component.html',
    styleUrls: ['./podcasts.component.css'],
    standalone: false
})
export class PodcastsComponent implements OnInit {
  readonly podcastCategories = [
    {value: 'bhakts_charitra', label: 'Bhakts Charitra'},
    {value: 'bhakts_books', label: 'Bhakts Books'},
    {value: 'bhakts_topics', label: 'Bhakts Topics'},
    {value: 'others', label: 'Others'}
  ];

  loading = true;
  loaders = Array(10).fill(0);
  count = 0;
  page = 1;
  perPage = 10;
  userKeyword = '';
  lookupUsers: any[] = [];
  initialLookupUsers: any[] = [];
  marketplaceBooks: any[] = [];
  podcasts: any[] = [];
  uploadingMedia: any = null;
  progress = 0;
  creatingPodcast = false;
  showCreateModal = false;
  showEditModal = false;
  savingEditPodcast = false;
  editUploadProgress = 0;
  editPodcast = {
    id: '',
    user: '',
    title: '',
    description: '',
    thumbnail: '',
    thumbnailFile: null,
    metadataLoading: false,
    metadataFetchedFor: '',
    category: 'others',
    marketplaceBookId: '',
    mediaType: 'upload',
    youtubeUrl: '',
    file: null,
    currentMedia: null,
    originalMediaType: 'upload'
  };
  mediaEntries: any[] = [];
  mediaEntryCounter = 0;
  currentUploadIndex = 0;
  totalEntriesToCreate = 0;
  filters = {
    keyword: '',
    sortBy: 'updated_desc',
    category: 'all',
    marketplaceBookId: ''
  };
  newPodcast = {
    user: null,
    category: 'others',
    marketplaceBookId: ''
  };

  constructor(
    private api: ApiService,
    private utils: UtilsService,
    private http: HttpClient
  ) {
  }

  ngOnInit(): void {
    this.mediaEntries = [this.createMediaEntry()];
    this.getUsers();
    this.getMarketplaceBooks();
    this.getPods();
  }

  getUsers(isInitial = true): void {
    this.api.getAllUsers({page: 1, per_page: 20, keyword: this.userKeyword}).subscribe(res => {
      this.lookupUsers = res.response.users || [];
      if (isInitial) {
        this.initialLookupUsers = this.lookupUsers;
      }
    }, err => this.utils.resErr(err));
  }

  handleUserInputChange(e): void {
    const value = e?.target?.value || '';
    this.userKeyword = value;
    if (value.length > 2) {
      this.getUsers(false);
      return;
    }
    this.lookupUsers = this.initialLookupUsers;
  }

  getPods(newPage: number = 1): void {
    this.page = newPage;
    const query = this.buildPodcastQuery(newPage);
    this.api.getPodcasts(query).subscribe(res => {
      const response = res?.response || {};
      this.podcasts = response.podcasts || [];
      this.count = response.total_count || 0;
      this.loading = false;
    }, err => {
      this.utils.resErr(err);
      this.loading = false;
    });
  }

  getMarketplaceBooks(): void {
    this.api.getMarketplaceBooks().subscribe(res => {
      const books = Array.isArray(res?.data) ? res.data : [];
      this.marketplaceBooks = books.sort((a, b) =>
        String(a?.name || '').localeCompare(String(b?.name || ''))
      );
    }, err => this.utils.resErr(err));
  }

  buildPodcastQuery(page: number = 1): any {
    const query: any = {
      page,
      per_page: this.perPage
    };

    const keyword = (this.filters.keyword || '').trim();
    if (keyword) {
      query.keyword = keyword;
    }

    if (this.filters.sortBy) {
      query.sort_by = this.filters.sortBy;
    }

    if (this.filters.category && this.filters.category !== 'all') {
      query.category = this.filters.category;
    }

    if (
      this.filters.category === 'bhakts_books' &&
      (this.filters.marketplaceBookId || '').trim()
    ) {
      query.marketplaceBookId = this.filters.marketplaceBookId.trim();
    }

    return query;
  }

  applyFilters(): void {
    this.loading = true;
    this.getPods(1);
  }

  clearFilters(): void {
    this.filters = {
      keyword: '',
      sortBy: 'updated_desc',
      category: 'all',
      marketplaceBookId: ''
    };
    this.loading = true;
    this.getPods(1);
  }

  handleFilterInputKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.applyFilters();
    }
  }

  hasActiveFilters(): boolean {
    return (
      !!(this.filters.keyword || '').trim() ||
      this.filters.sortBy !== 'updated_desc' ||
      this.filters.category !== 'all' ||
      !!(this.filters.marketplaceBookId || '').trim()
    );
  }

  onFilterCategoryChange(): void {
    if (this.filters.category !== 'bhakts_books') {
      this.filters.marketplaceBookId = '';
    }
  }

  podAction(idx: number, action: string): void {
    const podcast = this.podcasts[idx];
    const id = podcast?.id;
    if (action === 'edit') {
      this.openEditModal(podcast);
      return;
    }

    if (action === 'delete') {
      if (confirm('Are you sure you want to delete this podcast?')) {
        this.podcasts = this.podcasts.filter((_, index) => index !== idx);
        this.api.deletePodcast(id).subscribe(res => {
          this.getPods(this.page);
          this.utils.toastSuccess('Podcast deleted!!');
        }, err => this.utils.resErr(err));
      }
    }

  }

  createPodcast(): void {
    if (!this.newPodcast.user) {
      this.utils.toastError('Please select a user');
      return;
    }

    if (!this.mediaEntries.length) {
      this.utils.toastError('Please add at least one media entry');
      return;
    }

    if (!this.newPodcast.category) {
      this.utils.toastError('Please select podcast category');
      return;
    }

    if (
      this.newPodcast.category === 'bhakts_books' &&
      !(this.newPodcast.marketplaceBookId || '').trim()
    ) {
      this.utils.toastError('Please select a book for Bhakts Books category');
      return;
    }

    for (let i = 0; i < this.mediaEntries.length; i++) {
      const entry = this.mediaEntries[i];
      if (!(entry.title || '').trim()) {
        this.utils.toastError(`Please add a title in row ${i + 1}`);
        return;
      }
      if (!(entry.description || '').trim()) {
        this.utils.toastError(`Please add a description in row ${i + 1}`);
        return;
      }
      if (!entry.thumbnailFile && !(entry.thumbnail || '').trim()) {
        this.utils.toastError(`Please add a thumbnail in row ${i + 1}`);
        return;
      }
      if (entry.mediaType === 'youtube' && !this.isValidYoutubeUrl(entry.youtubeUrl)) {
        this.utils.toastError(`Please enter a valid YouTube URL in row ${i + 1}`);
        return;
      }
      if (entry.mediaType === 'upload' && !entry.file) {
        this.utils.toastError(`Please select a video file in row ${i + 1}`);
        return;
      }
    }

    this.creatingPodcast = true;
    this.uploadingMedia = 'new';
    this.currentUploadIndex = 0;
    this.totalEntriesToCreate = this.mediaEntries.length;
    this.createPodcastsFromMediaEntries(0, 0);
  }

  resetCreateForm(): void {
    this.newPodcast = {
      user: null,
      category: 'others',
      marketplaceBookId: ''
    };
    this.mediaEntries = [this.createMediaEntry()];
    this.currentUploadIndex = 0;
    this.totalEntriesToCreate = 0;
    this.uploadingMedia = null;
    this.progress = 0;
  }

  openCreateModal(): void {
    this.showCreateModal = true;
  }

  closeCreateModal(): void {
    this.showCreateModal = false;
    this.resetCreateForm();
  }

  openEditModal(podcast: any = null): void {
    if (!podcast?.id) {
      this.utils.toastError('Invalid podcast record');
      return;
    }

    const mediaType = this.isYoutubeMedia(podcast?.media) ? 'youtube' : 'upload';
    const requestedUser = podcast?.user;
    const requestedUserId = String(
      typeof requestedUser === 'object'
        ? requestedUser?.id || requestedUser?._id || ''
        : requestedUser || ''
    ).trim();

    if (
      requestedUserId &&
      typeof requestedUser === 'object' &&
      !this.lookupUsers.some(user => String(user?.id || user?._id) === requestedUserId)
    ) {
      const userOption = {...requestedUser, id: requestedUserId};
      this.lookupUsers = [userOption, ...this.lookupUsers];
      this.initialLookupUsers = [userOption, ...this.initialLookupUsers];
    }

    this.editPodcast = {
      id: podcast.id,
      user: requestedUserId,
      title: String(podcast?.title || '').trim(),
      description: String(podcast?.description || '').trim(),
      thumbnail: String(podcast?.thumbnail || podcast?.media?.thumb || '').trim(),
      thumbnailFile: null,
      metadataLoading: false,
      metadataFetchedFor: '',
      category: String(podcast?.category || 'others').toLowerCase(),
      marketplaceBookId: String(podcast?.marketplaceBook?._id || podcast?.marketplaceBookId || '').trim(),
      mediaType,
      youtubeUrl: mediaType === 'youtube' ? String(podcast?.media?.location || '').trim() : '',
      file: null,
      currentMedia: podcast?.media || null,
      originalMediaType: mediaType
    };
    this.editUploadProgress = 0;
    this.showEditModal = true;
  }

  closeEditModal(): void {
    if (this.savingEditPodcast) {
      return;
    }

    this.showEditModal = false;
    this.editUploadProgress = 0;
    this.editPodcast = {
      id: '',
      user: '',
      title: '',
      description: '',
      thumbnail: '',
      thumbnailFile: null,
      metadataLoading: false,
      metadataFetchedFor: '',
      category: 'others',
      marketplaceBookId: '',
      mediaType: 'upload',
      youtubeUrl: '',
      file: null,
      currentMedia: null,
      originalMediaType: 'upload'
    };
  }

  createMediaEntry(): any {
    this.mediaEntryCounter += 1;
    return {
      id: this.mediaEntryCounter,
      mediaType: 'upload',
      youtubeUrl: '',
      file: null,
      title: '',
      description: '',
      thumbnail: '',
      thumbnailFile: null,
      metadataLoading: false,
      metadataFetchedFor: ''
    };
  }

  addMediaEntry(): void {
    this.mediaEntries.push(this.createMediaEntry());
  }

  removeMediaEntry(index: number): void {
    if (this.mediaEntries.length === 1) {
      return;
    }
    this.mediaEntries.splice(index, 1);
  }

  updateMediaType(entry, mediaType: string): void {
    entry.mediaType = mediaType;
    entry.youtubeUrl = '';
    entry.file = null;
    entry.metadataFetchedFor = '';
  }

  onNewPodcastFileChange(e, entry): void {
    const file = e.target.files[0];
    entry.file = file || null;
  }

  onNewPodcastThumbnailChange(e, entry): void {
    const file = e?.target?.files?.[0];
    entry.thumbnailFile = file || null;
  }

  onEditPodcastFileChange(e): void {
    const file = e?.target?.files?.[0];
    this.editPodcast.file = file || null;
  }

  onEditPodcastThumbnailChange(e): void {
    const file = e?.target?.files?.[0];
    this.editPodcast.thumbnailFile = file || null;
  }

  onCreateCategoryChange(): void {
    if (this.newPodcast.category !== 'bhakts_books') {
      this.newPodcast.marketplaceBookId = '';
    }
  }

  onEditCategoryChange(): void {
    if (this.editPodcast.category !== 'bhakts_books') {
      this.editPodcast.marketplaceBookId = '';
    }
  }

  updateEditMediaType(mediaType: string = 'upload'): void {
    this.editPodcast.mediaType = mediaType;
    this.editPodcast.file = null;
    if (mediaType !== 'youtube') {
      this.editPodcast.youtubeUrl = '';
    }
  }

  fetchYoutubeMetadata(entry: any): void {
    const youtubeUrl = String(entry?.youtubeUrl || '').trim();
    if (
      !this.isValidYoutubeUrl(youtubeUrl) ||
      entry.metadataLoading ||
      entry.metadataFetchedFor === youtubeUrl
    ) {
      return;
    }

    entry.metadataLoading = true;
    this.api.getYoutubePodcastMetadata(youtubeUrl).subscribe(res => {
      const metadata = res?.response || {};
      entry.title = String(metadata.title || '').trim();
      entry.description = String(metadata.description || '').trim();
      entry.thumbnail = String(metadata.thumbnail || '').trim();
      entry.youtubeUrl = String(metadata.youtubeUrl || youtubeUrl).trim();
      entry.metadataFetchedFor = entry.youtubeUrl;
      entry.metadataLoading = false;
    }, err => {
      entry.metadataLoading = false;
      this.utils.resErr(err);
    });
  }

  fetchEditYoutubeMetadata(): void {
    this.fetchYoutubeMetadata(this.editPodcast);
  }

  saveEditedPodcast(): void {
    if (this.savingEditPodcast) {
      return;
    }

    if (!this.editPodcast.id) {
      this.utils.toastError('Invalid podcast id');
      return;
    }

    if (!this.editPodcast.user) {
      this.utils.toastError('Please select a user');
      return;
    }

    if (!this.editPodcast.category) {
      this.utils.toastError('Please select podcast category');
      return;
    }

    if (!(this.editPodcast.title || '').trim()) {
      this.utils.toastError('Please add a podcast title');
      return;
    }

    if (!(this.editPodcast.description || '').trim()) {
      this.utils.toastError('Please add a podcast description');
      return;
    }

    if (
      !this.editPodcast.thumbnailFile &&
      !(this.editPodcast.thumbnail || '').trim()
    ) {
      this.utils.toastError('Please add a podcast thumbnail');
      return;
    }

    if (
      this.editPodcast.category === 'bhakts_books' &&
      !(this.editPodcast.marketplaceBookId || '').trim()
    ) {
      this.utils.toastError('Please select a book for Bhakts Books category');
      return;
    }

    if (
      this.editPodcast.mediaType === 'youtube' &&
      !this.isValidYoutubeUrl(this.editPodcast.youtubeUrl) &&
      !this.isYoutubeMedia(this.editPodcast.currentMedia)
    ) {
      this.utils.toastError('Please enter a valid YouTube URL');
      return;
    }

    if (
      this.editPodcast.mediaType === 'upload' &&
      !this.editPodcast.file &&
      (!this.editPodcast.currentMedia ||
        this.isYoutubeMedia(this.editPodcast.currentMedia))
    ) {
      this.utils.toastError('Please upload a video file');
      return;
    }

    this.savingEditPodcast = true;
    this.prepareThumbnail(
      this.editPodcast.thumbnailFile,
      this.editPodcast.thumbnail,
      thumbnail => this.saveEditedPodcastWithThumbnail(thumbnail),
      () => {
        this.savingEditPodcast = false;
      }
    );
  }

  saveEditedPodcastWithThumbnail(thumbnail: string): void {
    this.editPodcast.thumbnail = thumbnail;

    if (this.editPodcast.mediaType === 'youtube') {
      const youtubeUrl = (this.editPodcast.youtubeUrl || '').trim();
      const existingMedia = this.editPodcast.currentMedia;
      if (!youtubeUrl && this.isYoutubeMedia(existingMedia)) {
        this.submitEditedPodcast({...existingMedia, thumb: thumbnail});
        return;
      }

      const media = this.buildYoutubeMedia(youtubeUrl, thumbnail);
      if (!media) {
        this.savingEditPodcast = false;
        this.utils.toastError('Please enter a valid YouTube URL');
        return;
      }
      this.submitEditedPodcast(media);
      return;
    }

    if (this.editPodcast.file) {
      this.uploadAndSaveEditedPodcast(thumbnail);
      return;
    }

    if (this.editPodcast.currentMedia && !this.isYoutubeMedia(this.editPodcast.currentMedia)) {
      this.submitEditedPodcast({
        ...this.editPodcast.currentMedia,
        thumb: thumbnail
      });
      return;
    }

    this.savingEditPodcast = false;
    this.utils.toastError('Please upload a video file');
  }

  uploadAndSaveEditedPodcast(thumbnail: string): void {
    const file = this.editPodcast.file;
    if (!file) {
      this.utils.toastError('Please select a video file');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    this.savingEditPodcast = true;
    this.editUploadProgress = 0;

    this.http.post('v2/media', formData, {
      reportProgress: true,
      observe: 'events',
    }).subscribe((res: any) => {
      if (res.type === HttpEventType.UploadProgress) {
        this.editUploadProgress = Math.round((100 * res.loaded) / res.total);
      } else if (res.type === HttpEventType.Response) {
        this.editUploadProgress = 0;
        this.submitEditedPodcast({
          ...res.body.response,
          thumb: thumbnail
        });
      }
    }, err => {
      this.savingEditPodcast = false;
      this.editUploadProgress = 0;
      this.utils.resErr(err);
    });
  }

  submitEditedPodcast(media: any = null): void {
    const payload = {
      id: this.editPodcast.id,
      user: this.editPodcast.user,
      title: String(this.editPodcast.title || '').trim(),
      description: String(this.editPodcast.description || '').trim(),
      thumbnail: String(this.editPodcast.thumbnail || '').trim(),
      category: this.editPodcast.category,
      marketplaceBookId:
        this.editPodcast.category === 'bhakts_books'
          ? String(this.editPodcast.marketplaceBookId || '').trim()
          : null,
      media
    };

    this.savingEditPodcast = true;
    this.api.updatePodcast(payload).subscribe(() => {
      this.savingEditPodcast = false;
      this.editUploadProgress = 0;
      this.utils.toastSuccess('Podcast updated successfully');
      this.closeEditModal();
      this.getPods(this.page);
    }, err => {
      this.savingEditPodcast = false;
      this.editUploadProgress = 0;
      this.utils.resErr(err);
    });
  }

  prepareThumbnail(
    file: File = null,
    currentThumbnail: string = '',
    onSuccess: (thumbnail: string) => void,
    onError: () => void = () => {}
  ): void {
    if (!file) {
      onSuccess(String(currentThumbnail || '').trim());
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    this.http.post('v2/media', formData).subscribe((res: any) => {
      const thumbnail = String(res?.response?.location || '').trim();
      if (!thumbnail) {
        this.utils.toastError('Thumbnail upload failed');
        onError();
        return;
      }
      onSuccess(thumbnail);
    }, err => {
      onError();
      this.utils.resErr(err);
    });
  }

  buildYoutubeMedia(url: string, thumbnail: string = ''): any {
    if (!this.isValidYoutubeUrl(url)) {
      return null;
    }

    const videoId = this.extractYoutubeVideoId(url);
    return {
      location: url.trim(),
      mimetype: 'text/youtube',
      thumb:
        String(thumbnail || '').trim() ||
        (videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : '')
    };
  }

  isValidYoutubeUrl(url: string = ''): boolean {
    const value = (url || '').trim();
    if (!value) {
      return false;
    }
    const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\//i;
    return youtubeRegex.test(value);
  }

  extractYoutubeVideoId(url: string = ''): string {
    const value = (url || '').trim();
    const youtubeRegex = /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/;
    const matches = value.match(youtubeRegex);
    return matches ? matches[1] : '';
  }

  isYoutubeMedia(media: any = null): boolean {
    if (!media) {
      return false;
    }
    const location = media.location || '';
    const mimeType = media.mimetype || '';
    return mimeType.toLowerCase().includes('youtube') || /youtube\.com|youtu\.be/i.test(location);
  }

  getRequestedByLabel(podcast: any): string {
    const user = podcast?.user;
    if (!user) {
      return 'Deleted User';
    }

    if (typeof user === 'string') {
      return user;
    }

    const firstName = String(user?.firstName || '').trim();
    const lastName = String(user?.lastName || '').trim();
    const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();
    if (fullName) {
      return fullName;
    }

    const fallbackIdentity = String(
      user?.username || user?.email || user?.id || user?._id || ''
    ).trim();
    if (fallbackIdentity) {
      return fallbackIdentity;
    }

    return 'Deleted User';
  }

  getPodcastCategoryLabel(category: string = ''): string {
    const normalized = String(category || '').trim().toLowerCase();
    const matched = this.podcastCategories.find((item) => item.value === normalized);
    return matched?.label || 'Others';
  }

  getPodcastBookLabel(podcast: any = null): string {
    if (!podcast) {
      return '--';
    }

    return (
      podcast?.marketplaceBook?.name ||
      podcast?.marketplaceBookName ||
      '--'
    );
  }

  viewPodcast = (url): Window => window.open(url, '_blank');

  pageChange(event): void {
    this.page = event;
    this.loading = true;
    this.getPods(event);
    window.scrollTo(0, 0);
  }

  handleCopyToClipboard(str: any = ''): void {
    this.utils.copyToClipboard(str);
    this.utils.toastSuccess('ID copied to your clipboard successfully');
  }

  handleUploadClick(id: any = ''): void {
    const ele = document.getElementById(id);
    if (!!ele) {
      ele.click();
    }
  }

  createPodcastsFromMediaEntries(entryIndex: number = 0, successCount: number = 0): void {
    if (entryIndex >= this.mediaEntries.length) {
      this.creatingPodcast = false;
      this.uploadingMedia = null;
      this.progress = 0;
      this.utils.toastSuccess(`${successCount} podcast${successCount > 1 ? 's' : ''} created successfully`);
      this.closeCreateModal();
      this.getPods(this.page);
      return;
    }

    const entry = this.mediaEntries[entryIndex];
    this.currentUploadIndex = entryIndex + 1;
    this.prepareThumbnail(
      entry.thumbnailFile,
      entry.thumbnail,
      thumbnail => this.createPodcastMediaEntry(
        entry,
        thumbnail,
        entryIndex,
        successCount
      ),
      () => {
        this.creatingPodcast = false;
        this.uploadingMedia = null;
      }
    );
  }

  createPodcastMediaEntry(
    entry: any,
    thumbnail: string,
    entryIndex: number,
    successCount: number
  ): void {
    if (entry.mediaType === 'youtube') {
      const media = this.buildYoutubeMedia(entry.youtubeUrl, thumbnail);
      this.progress = 0;
      this.api.createPodcast({
        user: this.newPodcast.user,
        title: String(entry.title || '').trim(),
        description: String(entry.description || '').trim(),
        thumbnail,
        media,
        category: this.newPodcast.category,
        marketplaceBookId:
          this.newPodcast.category === 'bhakts_books'
            ? this.newPodcast.marketplaceBookId
            : null
      }).subscribe(() => {
        this.createPodcastsFromMediaEntries(entryIndex + 1, successCount + 1);
      }, err => {
        this.creatingPodcast = false;
        this.uploadingMedia = null;
        this.progress = 0;
        this.utils.resErr(err);
      });
      return;
    }

    const file = entry.file;
    const formData = new FormData();
    formData.append('file', file);

    this.http
      .post('v2/media', formData, {
        reportProgress: true,
        observe: 'events',
      })
      .subscribe((res: any) => {
        if (res.type === HttpEventType.UploadProgress) {
          this.progress = Math.round((100 * res.loaded) / res.total);
        } else if (res.type === HttpEventType.Response) {
          this.progress = 0;
          this.api.createPodcast({
            user: this.newPodcast.user,
            title: String(entry.title || '').trim(),
            description: String(entry.description || '').trim(),
            thumbnail,
            media: {
              ...res.body.response,
              thumb: thumbnail
            },
            category: this.newPodcast.category,
            marketplaceBookId:
              this.newPodcast.category === 'bhakts_books'
                ? this.newPodcast.marketplaceBookId
                : null
          }).subscribe(() => {
            this.createPodcastsFromMediaEntries(entryIndex + 1, successCount + 1);
          }, err => {
            this.creatingPodcast = false;
            this.uploadingMedia = null;
            this.progress = 0;
            this.utils.resErr(err);
          });
        }
      }, err => {
        this.creatingPodcast = false;
        this.uploadingMedia = null;
        this.progress = 0;
        this.utils.resErr(err);
      });
  }
}
